import Lottie from '~/components/Lottie'
import { CSSProperties } from 'styled-components'
import animationData from '~/assets/lottie/spotswap-form-skeleton.json'
import animationDataDark from '~/assets/lottie/spotswap-form-skeleton-dark.json'
import { isDarkThemeName, useThemeName } from '~/theme'

interface SkeletonProps {
  style?: CSSProperties
}

const Skeleton: React.FC<SkeletonProps> = ({ style = {} }: SkeletonProps) => {
  const themeName = useThemeName()
  const animation = isDarkThemeName(themeName) ? animationDataDark : animationData

  const composedStyle = {
    width: 104,
    height: 20,
    ...style,
  }
  const options = {
    animationData: animation,
    loop: true,
    autoplay: true,
  }
  return <Lottie {...options} style={composedStyle} />
}

export default Skeleton
